const encodeBase64 = (obj: any) => {
  let str = obj;

  if (typeof obj !== "string") {
    str = JSON.stringify(obj);
  }

  return btoa(str);
};

export const getToken = (
  username: string,
  roles: string[],
  expirationTime: number = 24 * 60 * 60,
  customPayload?: object
) => {
  const now = Math.floor(Date.now() / 1000);
  const payload = {
    iat: now,
    exp: now + expirationTime,
    iss: "cypress-intercept",
    scope: "openid",
    sub: username,
    given_name: username
      .split("_")
      .map((s) => `${s.charAt(0).toUpperCase()} ${s.slice(1)}`)
      .join(" "),
    preferred_username: username,
    email: `${username}@dummy-mail.com`,
    roles,
    ...customPayload,
  };

  const header = {
    alg: "RS256",
    typ: "JWT",
    kid: "dummy",
  };

  const tokenHeader = encodeBase64(header);
  const tokenPayload = encodeBase64(payload);
  const tokenVerifySignature = "dummy";

  return `${tokenHeader}.${tokenPayload}.${tokenVerifySignature}`;
};
